import { FC, useMemo } from "react";
import { localeStringOptions } from "../../../../../common/constants/common.constants";
import { IProposalWithMetaData } from "../../../../../common/interfaces/proposals.interface";
import { divide, number, pow } from "mathjs";
import "./WithdrawalProposalInfoTable.scss";
import { getTrimmedPublicKey, round } from "../../../../../utilities/helpers";
import { ProposalAction } from "../../../../../common/enums/proposals.enums";
import { ITreasuryTokenAccInfo } from "../../../../../common/interfaces/clubs.interface";

const WithdrawalOrTransferProposalInfoTable: FC<{
  proposalWithMetaData: IProposalWithMetaData;
  treasuryTokens: ITreasuryTokenAccInfo[];
}> = ({ proposalWithMetaData, treasuryTokens }) => {
  const getWithdrawableAmount = useMemo(() => {
    return (
      proposalWithMetaData.metadata.proposalAction ===
        ProposalAction.Withdrawal &&
      proposalWithMetaData.metadata.withdrawalMembersInfo &&
      proposalWithMetaData.metadata.withdrawalMembersInfo.withdrawAmount &&
      round(
        number(
          proposalWithMetaData.metadata.withdrawalMembersInfo.withdrawAmount
        ),
        proposalWithMetaData.metadata.withdrawalMembersInfo
          .withdrawalMintDecimals
      )
    );
  }, [proposalWithMetaData]);

  const getWithdrawalAmount = useMemo(() => {
    return (
      proposalWithMetaData.metadata.proposalAction ===
        ProposalAction.Withdrawal &&
      proposalWithMetaData.metadata.withdrawalAmount &&
      divide(
        number(proposalWithMetaData.metadata.withdrawalAmount),
        Number(pow(10, proposalWithMetaData.metadata.mintDecimals))
      )
    );
  }, [proposalWithMetaData]);
  const getTransferAmount = useMemo(() => {
    const treasuryTokenAccount =
      proposalWithMetaData.metadata.proposalAction ===
        ProposalAction.Transfer &&
      treasuryTokens.find(
        (item) =>
          item.mint.toString() === proposalWithMetaData.metadata.mint.toString()
      );
    return (
      proposalWithMetaData.metadata.proposalAction ===
        ProposalAction.Transfer &&
      treasuryTokenAccount &&
      divide(
        number(proposalWithMetaData.metadata.amountToInvest),
        Number(pow(10, treasuryTokenAccount.decimals))
      )
    );
  }, [proposalWithMetaData]);

  return (
    <div className="withdrawal-proposal-table">
      <div className="withdrawal-proposal-table__item">
        <p className="withdrawal-proposal-table__label">
          Amount to{" "}
          {proposalWithMetaData.metadata.proposalAction ===
          ProposalAction.Transfer
            ? "transfer"
            : "be withdrawn"}
        </p>
        <p className="withdrawal-proposal-table__value">
          {proposalWithMetaData.metadata.proposalAction ===
          ProposalAction.Withdrawal
            ? `${getWithdrawalAmount.toLocaleString(
                undefined,
                localeStringOptions
              )}
           ${proposalWithMetaData.metadata.mintSymbol}`
            : `${getTransferAmount?.toLocaleString(
                undefined,
                localeStringOptions
              )}
          ${proposalWithMetaData.metadata.mintSymbol}`}
        </p>
      </div>
      <div className="withdrawal-proposal-table__item">
        <p className="withdrawal-proposal-table__label">
          {proposalWithMetaData.metadata.proposalAction ===
          ProposalAction.Transfer
            ? "Transfer to address"
            : "The amount I will get"}
        </p>
        <p className="withdrawal-proposal-table__value withdrawal-proposal-table__value--members-amount">
          {proposalWithMetaData.metadata.proposalAction ===
          ProposalAction.Withdrawal
            ? `${getWithdrawableAmount}
           ${proposalWithMetaData.metadata.mintSymbol}`
            : `${proposalWithMetaData.metadata.destination.toString()}
          `}
        </p>
      </div>
    </div>
  );
};

export default WithdrawalOrTransferProposalInfoTable;
